export const FilterWrapperMarker = Symbol('FilterWrapperMarker');
//# sourceMappingURL=StamhoofdFilterTypes.js.map